// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Now_body__WblZS {\n  display: flex;\n}\n", "",{"version":3,"sources":["webpack://./src/views/Search/SearchDesktop/Content/Now/Now.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf","sourcesContent":[".body {\n  display: flex;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"body": "Now_body__WblZS"
};
export default ___CSS_LOADER_EXPORT___;
